/**
 * Handles displaying the name of uploaded files in file input fields, updates the icons / styling used
 * within the component depending on state
 */
const handleFileUpload = () => {
    const fileInputs = document.querySelectorAll('.FormFileUpload__Input');
    const uploadedFiles = {};
    fileInputs.forEach((input) => {
        input.addEventListener('change', (event) => {
            const target = event.target;
            const files = target.files;
            if (files && files.length > 0) {
                const fileName = files[0].name;
                const fileNameParts = fileName.split('.');
                const fileExtension = fileNameParts.pop() || '';
                const mainText = fileNameParts.join('.');
                const truncatedMainText = mainText.length > 20 ? `${mainText.slice(0, 12)}…` : mainText;
                const displayName = `${truncatedMainText}.${fileExtension}`;
                uploadedFiles[target.name] = fileName;
                target.style.setProperty('--file-name', `'${displayName}'`);
                target.classList.add('file-uploaded');
            }
            else {
                // File was removed
                delete uploadedFiles[target.name];
                target.style.removeProperty('--file-name');
                target.classList.remove('file-uploaded');
            }
        });
    });
};
export default handleFileUpload;
